import { Button, Col, Row, Tag } from "antd";
import { capitalizeLetter } from "../../../utils/capitalizeLetter";
import dayjs from "dayjs";
const TableColumn = (navigateDetail, onDelete) => {
  const data = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      width: 60,
      render: (no) => no,
    },
    {
      title: "Tanggal Request",
      dataIndex: "request_at",
      key: "request_at",
      width: 180,
      sorter: (a, b) => {
        if (a.request_at === null || a.request_at === "-") return 1;
        if (b.request_at === null || b.request_at === "-") return -1;
        return a.request_at.localeCompare(b.request_at);
      },
      render: (request_at) => {
        if (request_at === null || request_at === "-") {
          return "-";
        } else {
          return dayjs(request_at).format("DD-MM-YYYY");
        }
      },
    },
    {
      title: "Pemilik",
      dataIndex: "client",
      key: "client",
      width: 150,
      sorter: (a, b) => {
        if (a.client?.name === null || a.client?.name === "-") return 1;
        if (b.client?.name === null || b.client?.name === "-") return -1;
        return a.client?.name.localeCompare(b.client?.name);
      },
      render: (client) => {
        if (client?.name === null || client?.name === "-") {
          return "-";
        } else {
          return client?.name;
        }
      },
    },
    {
      title: "Jenis Produk dan Estimasi Berat",
      dataIndex: "transaction_details",
      key: "transaction_details",
      render: (transaction_details) => {
        if (transaction_details.length < 1) {
          return "-";
        } else {
          const mergedProductMap = new Map();

          transaction_details.forEach((item) => {
            const name = item?.product?.name;
            const existing = mergedProductMap.get(name);

            if (existing) {
              existing.estimate_weight += item.estimate_weight;
            } else {
              mergedProductMap.set(name, { ...item });
            }
          });

          const mergedProductArray = Array.from(mergedProductMap.values());

          const formatted = mergedProductArray.map((item, index) => {
            const text = `${
              item.product?.name
            } ${item.estimate_weight?.toLocaleString("id-ID", {
              minimumFractionDigits: 1,
              maximumFractionDigits: 1,
            })} Kg`;

            const needsBreak =
              (index + 1) % 3 === 0 && index !== mergedProductArray.length - 1;

            return needsBreak ? (
              <span>
                {text} <br />
              </span>
            ) : (
              `${text}, `
            );
          });

          return <>{formatted}</>;
        }
      },
    },
    {
      title: "Tanggal Keluar",
      dataIndex: "schedule_at",
      key: "schedule_at",
      width: 150,
      sorter: (a, b) => {
        if (a.schedule_at === null || a.schedule_at === "-") return 1;
        if (b.schedule_at === null || b.schedule_at === "-") return -1;
        return a.schedule_at.localeCompare(b.schedule_at);
      },
      render: (schedule_at) => {
        return dayjs(schedule_at).format("YYYY-MM-DD") ?? "-";
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      sorter: (a, b) => {
        if (a.status === null || a.status === "-") return 1;
        if (b.status === null || b.status === "-") return -1;
        return a.status.localeCompare(b.status);
      },
      render: (status) => {
        if (status === null || status === "") {
          return "-";
        } else {
          return status === "pending" ? (
            <Tag color="orange">{capitalizeLetter(status)}</Tag>
          ) : status === "reject" ? (
            <Tag color="red">{capitalizeLetter(status)}</Tag>
          ) : (
            <Tag color="green">{capitalizeLetter(status)}</Tag>
          );
        }
      },
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 180,
      render: (resultData) => {
        return (
          <Row gutter={[8, 8]} size="middle">
            <Col>
              <Button type="primary" onClick={() => navigateDetail(resultData)}>
                Detail
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];
  return data;
};
export default TableColumn;
